export default "__VITE_ASSET__DRuk8CWW__"